import styled, { css } from 'styled-components/macro';

import { MEDIUM_MEDIA_QUERY_WIDTH } from '../../styles';

import { TrialInputWrapper } from '../Trials/styles';

const FieldWrapperStyles = css`
  display: flex;
  justify-content: stretch;

  > div {
    flex: 1;
    margin-right: 16px;
    width: 100%;
  }

  > div:last-child {
    margin-right: 0;
  }

  @media (max-width: ${MEDIUM_MEDIA_QUERY_WIDTH}px) {
    display: block;
  }
`;

export const BusinessDetailsFormCityStateWrapper = styled.div`
  ${FieldWrapperStyles};

  > div:last-child {
    max-width: 28%;
  }

  @media (max-width: ${MEDIUM_MEDIA_QUERY_WIDTH}px) {
    > div:last-child {
      max-width: 100%;
      margin-bottom: 24px;
    }
  }
`;

export const BusinessDetailsFormZipPhoneWrapper = styled.div`
  ${FieldWrapperStyles};

  > div:first-child {
    max-width: 28%;
  }

  ${TrialInputWrapper} {
    margin-bottom: 0;
  }

  @media (max-width: ${MEDIUM_MEDIA_QUERY_WIDTH}px) {
    > div:first-child {
      max-width: 100%;
      margin-bottom: 24px;
    }
  }
`;

const inputWrapperSxStyles = {
  '> div': {
    flex: 1,
    marginRight: '16px',
    width: '100%',
  },
  '> div:last-child': {
    marginRight: 0,
  },
};

export const getBusinessDetailsDoubleFieldWrapperStyles = ({
  childOrder = 'first',
  isMobile,
  maxWidth = '40%',
} = {}) => ({
  display: isMobile ? 'block' : 'flex',
  justifyContent: 'stretch',
  sx: {
    ...inputWrapperSxStyles,
    [`> div:${childOrder}-of-type`]: {
      ...(isMobile && { marginBottom: '24px' }),
      maxWidth: isMobile ? '100%' : maxWidth,
    },
  },
});
